import type { RouteRecordRaw } from 'vue-router';

const MobileLayout = () => import('@/m/layouts/MobileLayout.vue');

export const mobileRoutes: RouteRecordRaw[] = [
  {
    path: '/m/login',
    name: 'm-login',
    component: () => import('@/m/views/login/Login.vue'),
    meta: { public: true, title: '登录' },
  },
  {
    path: '/m/trial',
    name: 'm-trial',
    component: () => import('@/m/views/login/Trial.vue'),
    meta: { public: true, title: '免费试用' },
  },
  {

    path: '/m',
    component: MobileLayout,
    children: [
      {
        path: 'dashboard',
        name: 'm-dashboard',
        component: () => import('@/m/views/dashboard/Dashboard.vue'),
        meta: { title: '工作台' },
      },
      {
        path: 'vehicles',
        name: 'm-vehicle-list',
        component: () => import('@/m/views/vehicle/VehicleList.vue'),
        meta: { title: '车辆', permissions: ['vehicle:list'] },
      },
      {
        path: 'vehicles/create',
        name: 'm-vehicle-create',
        component: () => import('@/m/views/vehicle/VehicleCreate.vue'),
        meta: { title: '新增车辆', permissions: ['vehicle:create'] },
      },
      {
        path: 'vehicles/:uuid',
        name: 'm-vehicle-detail',
        component: () => import('@/m/views/vehicle/VehicleDetail.vue'),
        meta: { title: '车辆详情', permissions: ['vehicle:detail'] },
      },
      {
        path: 'vehicles/:uuid/edit',
        name: 'm-vehicle-edit',
        component: () => import('@/m/views/vehicle/VehicleEdit.vue'),
        meta: { title: '编辑车辆', permissions: ['vehicle:update'] },
      },
      {
        path: 'evaluations',
        name: 'm-evaluation-list',
        component: () => import('@/m/views/evaluation/EvaluationList.vue'),
        meta: { title: '评估', permissions: ['evaluation:list'] },
      },
      {
        path: 'evaluations/create',
        name: 'm-evaluation-create',
        component: () => import('@/m/views/evaluation/EvaluationCreate.vue'),
        meta: { title: '新增评估', permissions: ['evaluation:create'] },
      },
      {
        path: 'evaluations/:uuid',
        name: 'm-evaluation-edit',
        component: () => import('@/m/views/evaluation/EvaluationEdit.vue'),
        meta: { title: '编辑评估', permissions: ['evaluation:update'] },
      },
      {
        path: 'customers',
        name: 'm-customer-list',
        component: () => import('@/m/views/customer/CustomerList.vue'),
        meta: { title: '客户', permissions: ['customer:list'] },
      },
      {
        path: 'customers/:uuid',
        name: 'm-customer-detail',
        component: () => import('@/m/views/customer/CustomerDetail.vue'),
        meta: { title: '客户详情', permissions: ['customer:detail'] },
      },
      {
        path: 'appointments',
        name: 'm-appointment-list',
        component: () => import('@/m/views/appointment/AppointmentList.vue'),
        meta: { title: '预约', permissions: ['appointment:list'] },
      },
      {
        path: 'preparations',
        name: 'm-preparation-list',
        component: () => import('@/m/views/preparation/PreparationList.vue'),
        meta: { title: '整备', permissions: ['preparation:list'] },
      },
      {
        path: 'finance',
        name: 'm-finance-list',
        component: () => import('@/m/views/finance/FinanceList.vue'),
        meta: { title: '财务', permissions: ['finance:list'] },
      },
      {
        path: 'finance/vehicle-profit',
        name: 'm-vehicle-profit',
        component: () => import('@/m/views/finance/VehicleProfit.vue'),
        meta: { title: '单车利润', permissions: ['finance:summary'] },
      },
      {
        path: 'profile',
        name: 'm-profile',
        component: () => import('@/m/views/profile/Profile.vue'),
        meta: { title: '我的' },
      },
      {
        path: 'org-settings',
        name: 'm-org-settings',
        component: () => import('@/m/views/org/OrgSettings.vue'),
        meta: { title: '机构设置', permissions: ['org:update'] },
      },
      {
        path: 'wechat-bind',
        name: 'm-wechat-bind',
        component: () => import('@/m/views/wechat/WechatBind.vue'),
        meta: { public: true, title: '微信绑定' },
      },
      {
        path: 'todos',
        name: 'm-todo-list',
        component: () => import('@/m/views/todo/TodoList.vue'),
        meta: { title: '代办事宜', permissions: ['todo:list'] },
      },
      {
        path: 'todos/create',
        name: 'm-todo-create',
        component: () => import('@/m/views/todo/TodoCreate.vue'),
        meta: { title: '新增待办', permissions: ['todo:create'] },
      },
      {
        path: 'todos/:uuid',
        name: 'm-todo-detail',
        component: () => import('@/m/views/todo/TodoDetail.vue'),
        meta: { title: '待办详情', permissions: ['todo:list'] },
      },
      {
        path: 'purchase-orders',
        name: 'm-purchase-order-list',
        component: () => import('@/m/views/order/PurchaseOrderList.vue'),
        meta: { title: '采购单', permissions: ['purchase_order:list'] },
      },
      {
        path: 'sales-orders',
        name: 'm-sales-order-list',
        component: () => import('@/m/views/order/SalesOrderList.vue'),
        meta: { title: '销售单', permissions: ['sales_order:list'] },
      },
      {
        path: 'inventory',
        name: 'm-inventory-list',
        component: () => import('@/m/views/inventory/InventoryList.vue'),
        meta: { title: '库存', permissions: ['inventory:list'] },
      },
      {
        path: 'parts',
        name: 'm-parts-list',
        component: () => import('@/m/views/inventory/PartsList.vue'),
        meta: { title: '配件', permissions: ['inventory:list'] },
      },
      {
        path: 'coupons',
        name: 'm-coupon-list',
        component: () => import('@/m/views/coupon/CouponList.vue'),
        meta: { title: '优惠券', permissions: ['coupon:list'] },
      },
      {
        path: 'activities',
        name: 'm-activity-list',
        component: () => import('@/m/views/activity/ActivityList.vue'),
        meta: { title: '活动', permissions: ['activity:list'] },
      },
      {
        path: 'leads',
        name: 'm-lead-list',
        component: () => import('@/m/views/lead/LeadList.vue'),
        meta: { title: '线索', permissions: ['lead:list'] },
      },
      {
        path: 'contracts',
        name: 'm-contract-list',
        component: () => import('@/m/views/contract/ContractList.vue'),
        meta: { title: '合同', permissions: ['contract:list'] },
      },
      {
        path: 'transfers',
        name: 'm-transfer-list',
        component: () => import('@/m/views/transfer/TransferList.vue'),
        meta: { title: '过户', permissions: ['transfer:list'] },
      },
      {
        path: 'select-org',
        name: 'm-select-org',
        component: () => import('@/m/views/org/SelectOrg.vue'),
        meta: { public: true, title: '选择机构' },
      },
      {
        path: 'super-admin',
        name: 'm-super-admin',
        component: () => import('@/m/views/super-admin/SuperAdmin.vue'),
        meta: { title: '超管工作台', roles: ['super_admin'] },
      },
    ],
  },
  {
    path: '/m/admin-login-confirm',
    name: 'm-admin-login-confirm',
    component: () => import('@/m/views/login/AdminLoginConfirm.vue'),
    meta: { public: true, title: '扫码确认登录' },
  },
  {
    path: '/m/create-org',
    name: 'm-create-org',
    component: () => import('@/m/views/org/CreateOrg.vue'),
    meta: { public: true, title: '创建机构' },
  },
];
